import { render, staticRenderFns } from "./CmgOrderConfirmationCancelOrder.vue?vue&type=template&id=0bd4516a&scoped=true&lang=pug"
import script from "./cmg-order-confirmation-cancel-order.ts?vue&type=script&lang=ts&external"
export * from "./cmg-order-confirmation-cancel-order.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgOrderConfirmationCancelOrder.vue?vue&type=style&index=0&id=0bd4516a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd4516a",
  null
  
)

export default component.exports